const RedirectSite = () => {
  window.location.href = "/gamePage/gameView.html";
  return <></>;
};

export default RedirectSite;